import React from 'react'
import { InboxSuccess } from './Inbox/InboxSuccess'
import { InboxUpsellBody, InboxUpsellFeatures } from './Inbox/InboxUpsell'
import { ProfessionalSuccess } from './Professional/ProfessionalSuccess'
import { InboxTimeline } from './Inbox/InboxTimeline'
import { DeltaTrialTimelineProps } from './Timeline/DeltaTrialTimeline'
import { ProfessionalTimeline } from './Professional/ProfessionalTimeline'
import { ProcessDocumentUpsellBody, ProcessDocumentUpsellFeatures } from './ProcessDocument/ProcessDocumentUpsell'
import { ProcessDocumentTimeline } from './ProcessDocument/ProcessDocumentTimeline'
import { ProcessDocumentSuccess } from './ProcessDocument/ProcessDocumentSuccess'
import { env } from '../../../common/util'

const professionalPlanId = { prod: '4hogzjs8p3zwu87y', staging: '', dev: 'ex1c48e86bqiqdjr' }
const ultimatePlanId = { prod: '24mu0d85fzuhqi5x', staging: '', dev: 'dmbv3q0nq9pf8dyd' }

export interface DeltaTrialFeature {
  id: string
  name: string
  planId: string
  calendly: string
  UpsellBody: React.ComponentType
  UpsellFeatures: React.ComponentType
  DeltaTrialTimeline: React.ComponentType<DeltaTrialTimelineProps>
  DeltaTrialSuccess: React.ComponentType
}

export const DELTA_TRIAL_FEATURES: { [key: string]: DeltaTrialFeature } = {
  inbox: {
    id: 'inbox',
    name: 'Inbox',
    planId: ultimatePlanId[env],
    calendly: 'https://calendly.com/financial-advisor-zocks-discussion/email-hub-demo?utm_source=in-app',
    UpsellBody: InboxUpsellBody,
    UpsellFeatures: InboxUpsellFeatures,
    DeltaTrialTimeline: InboxTimeline,
    DeltaTrialSuccess: InboxSuccess,
  },
  processDocument: {
    id: 'processDocument',
    name: 'Document Intelligence',
    planId: ultimatePlanId[env],
    calendly: 'https://calendly.com/financial-advisor-zocks-discussion/ultimate-plan-demo-ia',
    UpsellBody: ProcessDocumentUpsellBody,
    UpsellFeatures: ProcessDocumentUpsellFeatures,
    DeltaTrialTimeline: ProcessDocumentTimeline,
    DeltaTrialSuccess: ProcessDocumentSuccess,
  },
  professional: {
    id: 'professional',
    name: 'Professional features',
    planId: professionalPlanId[env],
    calendly: 'https://calendly.com/financial-advisor-zocks-discussion/zocks-professional?utm_source=in-app',
    UpsellBody: () => null,
    UpsellFeatures: () => null,
    DeltaTrialTimeline: ProfessionalTimeline,
    DeltaTrialSuccess: ProfessionalSuccess,
  },
}
